function filterData(data) {
  const filteredObj = {};
  filteredObj.temp = data.data.weatherData.temp_c || '';
  filteredObj.iconCode = data.data.weatherData.condition.code || '';
  filteredObj.skyCover = data.data.weatherData.condition.text || '';
  filteredObj.isDay = !!data.data.weatherData.is_day;
  return filteredObj;
}
function filterLocation(data) {
  let postalID = '';
  const newArry =
    Array.isArray(data.location.postalCode) &&
    data.location.postalCode.length > 0 &&
    data.location.postalCode.filter(item => item);
  postalID = Array.isArray(newArry) && newArry.length > 0 && newArry[0];
  return postalID;
}
function filterLocationId(data, city) {
  let postalID = '';
  const currentCity = city && city === 'delhi' ? 'New Delhi' : city;
  const newArry =
    Array.isArray(data) &&
    data.length > 0 &&
    data?.find(
      item =>
        item.weather_city_name?.toLowerCase() === currentCity?.toLowerCase(),
    );
  postalID = newArry && newArry?.postal;
  return postalID;
}

export default { filterData, filterLocation, filterLocationId };
